export default __webpack_public_path__ + "static/char-s-56-zh-Hans-44fdb68966def54c19fb45591bee8b06.png";